import React from "react";
import tw, { styled, css } from "twin.macro";
import { graphql, Link, useStaticQuery } from "gatsby";
import { getImage, GatsbyImage, withArtDirection } from "gatsby-plugin-image";

const styles = ({ header }) => [
  tw`max-w-[25rem] [.gatsby-image-wrapper]:object-contain! [img]:object-contain!`,
];

const Div = styled.div(() => styles);
const A = styled(Link)(() => styles);

const Logo = ({ to, header, ...rest }) => {
  const { logo, logoIcon } = useStaticQuery(graphql`
    query {
      wp {
        esquireAcf {
          firmInformation {
            logo {
              ...GatsbyImage_SVG
            }
            logoIcon {
              ...GatsbyImage_SVG
            }
          }
        }
      }
    }
  `).wp.esquireAcf.firmInformation;

  const Outer = !!to ? A : Div;
  const image = withArtDirection(getImage(logo.localFile), [
    {
      media: "(max-width: 639px)",
      image: getImage(!!logoIcon ? logoIcon?.localFile : logo.localFile),
    },
  ]);

  return (
    <Outer header={header} to={to} aria-label={!!to ? "Home" : ""} {...rest}>
      <GatsbyImage image={image} alt="Firm Logo" />
    </Outer>
  );
};

export default Logo;
